import actions from './actions';

const initState = {
    error: "",
    status: "",
    message: "",
    code: "",
};

export default function reducer(state = initState, action) {
    switch (action.type) {
        case actions.SHOW_NOTIFICATION:
            return {
                ...state,
                error: action.error,
                status: action.status,
                message: action.message,
                code: action.code,
                duration: action.duration,
            };
        case actions.CLEAR_NOTIFICATION:
            return {
                ...state,
                error: "",
                status: "",
                message: "",
                code: "",
            };
        default:
            return state;
    }

}
